import React, {useRef, useMemo, useEffect, useState} from 'react';

import {getClientCity, getCityConfig} from 'ultra/configs/general';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import {useConfigStore} from '../../../Stores/config';
import {useFormStore} from '../../../Stores/form';

import MapContainer from './MapContainer';

import './index.scss';

export default function Location(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const {configs} = useConfigStore();
    const [cityConfig] = useState(getCityConfig(configs, getClientCity(window)));

    const [mode, setMode] = useState(null);

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable));
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled]);

    // const [addComment, setAddComment] = useState(Boolean(content[field.id]?.comment));
    const [comment, setComment] = useState(content[field.id]?.comment);
    const [title, setTitle] = useState(content[field.id]?.title);
    const [address, setAddress] = useState(content[field.id]?.address);

    const [defaultCenter] = useState({ lat: Number(content?.[field.id]?.lat || cityConfig.location.lat), lng: Number(content?.[field.id]?.lng || cityConfig.location.lng) }); // setDefaultCenter
    const [defaultZoom] = useState(content?.[field.id]?.lat ? 16 : cityConfig.location.zoom); // setDefaultZoom

    const componentRef = useRef(null);

    const valueRef = useRef(null);
    const setValueRef = data => {
        valueRef.current = data;
    };

    const [ignoreControlCheck, setIgnoreControlCheck] = useState(true);

    const hasInteractionRef = useRef(null);
    const setHasInteraction = data => {
        hasInteractionRef.current = data;
    };

    const className = useMemo(() => {
        return 'Location'
        + (isDisabled ? ' disabled' : '')
        + (
            (
                (!hasInteractionRef.current)
                || (!ignoreControlCheck && hasInteractionRef.current)
            )
            && showErrorText ? ' error' : ''
        )
    }, [isDisabled, showErrorText, ignoreControlCheck, content[field.id]]);

    const handleClickOutside = (e) => {
        const clickOutside = componentRef.current && !componentRef.current.contains(e.target);

        if (!hasInteractionRef.current) {
            if (!clickOutside) setHasInteraction(true);
        }
        else if (clickOutside) {
            setIgnoreControlCheck(false);
            onBlur({target: {value: valueRef.current}});
        }
        else {
            setIgnoreControlCheck(true);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const newValue = {...content[field.id]} || {};
        setValueRef(newValue);

        // if (newValue.comment) setAddComment(true);

        setTitle(newValue.title);
        setAddress(newValue.address);
        setComment(newValue.comment);
    }, [content[field.id]])

    const onModeChange = (e) => {
        // setIgnoreControlCheck(true);
        setMode(e);
    }

    const onMarkerChange = (e) => {
        const v = {...e.target.value};
        if (comment) v.comment = comment;
        else delete v.comment;
        onChange({target: {value: v}});
    }

    const onCommentChange = (e) => {
        let result = {...valueRef?.current};
        result.comment = e.target.value || "";
        setComment(result.comment);
        onChange({target: {value: result}});
    }

    const onCommentBlur = (e) => {
        // setIgnoreControlCheck(false);
        onBlur({target: {value: content[field.id]}});
        // let result = {...valueRef?.current};
        // result.comment = e.target.value || "";
        // setIgnoreControlCheck(false);
        // onBlur({target: {value: result}});
    }

    return (<>
        <div className={className} ref={componentRef}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <div className='FormFieldsGroupLabel'>
                        {field.placeholder} {field.required ? '*' : ''}
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='FormFieldsGroup'>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MapContainer
                                    content={content}
                                    field={field}
                                    showControls={true}

                                    defaultZoom={defaultZoom}
                                    defaultCenter={defaultCenter}
                                    value={valueRef?.current}

                                    onModeChange={onModeChange}
                                    onChange={onMarkerChange}
                                />
                            </Grid>

                            {(title || address) && 
                                <Grid item xs={12}>
                                    <div className='locationDetails'>
                                        {(mode === "touch" || mode === "search" || !mode) && <div className='title'>{title}</div>}
                                        {mode !== "touch" && address && <div className='label'>Адреса:</div>}
                                        <div className='address'>
                                            {mode === "touch" && <>Адреса: </>}
                                            {address}
                                        </div>
                                        <div className="comment">
                                            <TextField
                                                fullWidth
                                                disabled={isDisabled}
                                                value={comment}
                                                label="Коментар"
                                                variant="outlined"
                                                onChange={onCommentChange}
                                                onBlur={onCommentBlur}
                                                multiline
                                                minRows={3}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            }

                            {/* <Grid item xs={12}>
                                <span className='pseudoLinkWrap'>
                                    {addComment ? '- ' : '+ '}  <span className='pseudoLink' onClick={() => {
                                        if (comment) onCommentChange({target: {value: ""}});
                                        setAddComment(!addComment)
                                    }}>{addComment ? 'Приховати ' : 'Додати '} коментар</span>
                                </span>
                            </Grid>

                            {addComment && <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={isDisabled}
                                    value={comment}
                                    label="Коментар"
                                    variant="outlined"
                                    onChange={onCommentChange}
                                    onBlur={onCommentBlur}
                                    multiline
                                    minRows={3}
                                />
                            </Grid>} */}
                            {/* {content[field.id] && <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={isDisabled}
                                    value={comment}
                                    label="Коментар"
                                    variant="outlined"
                                    onChange={onCommentChange}
                                    onBlur={onCommentBlur}
                                    multiline
                                    minRows={3}
                                />
                            </Grid>} */}
                        </Grid>
                    </div>
                </Grid>
                {content?.[field.id]?.lat && (!title && !address) && <Grid item xs={12}>
                    <div className='locationDetails'>
                        <div className="comment">
                            <TextField
                                fullWidth
                                disabled={isDisabled}
                                value={comment}
                                label="Коментар"
                                variant="outlined"
                                onChange={onCommentChange}
                                onBlur={onCommentBlur}
                                multiline
                                minRows={3}
                            />
                        </div>
                    </div>
                </Grid>}
            </Grid>
        </div>
        {!ignoreControlCheck && showErrorText && <div className='fieldError'>
            {showErrorText}
        </div>}
    </>)
}
